'use strict';
// @flow
const angular = require('angular');

interface User {
  email: string;
  password: string;
  membership: {
    firstName: string;
    lastName: string;
    address1: string;
    address2: string;
    city: string;
    zip: string;
    country: string;
    defaultPickupOption: any;
    phoneNumber: string;
  }
}

export default class SignupController {
  user: User = {
    email: '',
    password: '',
    membership: {
      firstName: '',
      lastName: '',
      address1: '',
      address2: '',
      city: '',
      zip: '',
      country: '',
      defaultPickupOption: null,
      phoneNumber: ''
    }
  };
  errors = {};
  submitted = false;
  Auth;
  $state;
  TranslationService
  activePickupOptions :any;

  isAgreeWithTerms: boolean = false;

  /*@ngInject*/
  constructor(Auth, $state, $http, TranslationService) {
    this.Auth = Auth;
    this.$state = $state;
    this.TranslationService = TranslationService;

    let scope = this;
    $http.get('/api/pickupOptions/current')
    .then( (res) => {
      scope.activePickupOptions = res.data;
    });
  }

  setAgreeWithTerms(event) {
    this.isAgreeWithTerms = event.target.checked;
  }

  changeField(field) {
    field.$setValidity('mongoose', true);
  }

  register(form) {
    this.submitted = true;
    
    if(form.$valid) {
      form.confirmPassword.$invalid = false;
      form.confirmPassword.$valid = true;
      form.confirmPassword.$error.match = false;

      if(form['password'].$viewValue == form['confirmPassword'].$viewValue){
        
        return this.Auth.createUser({
          email: this.user.email,
          password: this.user.password,
          membership: {
            firstName: this.user.membership.firstName.charAt(0).toUpperCase() 
                + this.user.membership.firstName.substring(1).toLowerCase(),
            lastName: this.user.membership.lastName.charAt(0).toUpperCase()
                + this.user.membership.lastName.substring(1).toLowerCase(),
            address1: this.user.membership.address1,
            address2: this.user.membership.address2,
            city: this.user.membership.city,
            zip: this.user.membership.zip,  
            country: this.user.membership.country,
            phoneNumber: this.user.membership.phoneNumber,
            creationDate: new Date(),
          }
        })
        .then(() => {
          // Account created, redirect to home
                  this.$state.go('membership');      })
        .catch(err => {
          this.errors = {};
          
          if (err.data.name == 'ValidationError') {
            for (let field in err.data.errors) {
              if (err.data.errors[field].kind == 'EXIST' && field=='email') {
                form[field].$setValidity('mongoose', false);
                this.errors[field] = this.TranslationService.translate('email_error_exist');
              }
            }
          }
          /* err = err.data;
          this.errors = {};
          // Update validity of form fields that match the mongoose errors
          angular.forEach(err.errors, (error, field) => {
            form[field].$setValidity('mongoose', false);
            this.errors[field] = error.message;
          }); */
  
        });
      
      } else { //Password == confirmPassword
        form.confirmPassword.$invalid = true;
        form.confirmPassword.$valid = false;
        form.confirmPassword.$error.match = true;
      }
      
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/signup/signup.controller.ts